<template>
  <section>
    <loading :active.sync="is_loading"></loading>
    <div id="breadcrumbs">
      <div class="bg-light py-3">
        <div class="container">
          <div class="row">
            <div class="col-md-12 mb-0">
              <div class="text-left">
                <router-link to="/">Home</router-link>
                <span class="mx-2 mb-0">/</span>
                <strong class="text-black">Revista digital</strong>
              </div>
            </div>
          </div>
          <!-- .row -->
        </div>
        <!-- .container -->
      </div>
      <!-- .bg-light -->
    </div>
    <div>
      <h2 class="pt-4">Revistas digitales</h2>
      <div class="container containerMagazines">
        <div class="row">
          <div
            v-for="magazine in magazines"
            :key="magazine.id"
            class="col-12 col-md-6 col-lg-4 pb-5 pb-md-0"
          >
            <button
              class="button-magazine"
              @click="getPdf(magazine.publication_year, magazine.publication_month)"
            >
              <img
                class="magazine-img-grid"
                :src="magazine.small_picture"
                alt="magazine"
                loading="lazy"
              />
            </button>
            <h4 class="mt-2">{{ magazine.name }}</h4>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>



<script>
import Loading from "vue-loading-overlay";
const axios = require("axios");

export default {
  name: "magazine",
  props: ["active"],
  components: {
    Loading,
  },

  created() {
    this.is_loading = true;
    if (!$cookies.isKey("utoken")) {
      this.$router.push("/");
    }

    if (!this.active) {
      this.$router.push("/profile");
    }
    this.getProducts();
    // this.getPages();
  },
  methods: {
    getProducts: function () {
      axios({
        method: "GET",
        url:
          this.api_url +
          "/subscriber/" +
          $cookies.get("uidmmkg") +
          "/retrieve-magazines",
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + $cookies.get("ctoken"),
        },
      })
        .then((response) => {
          console.log("retrieve magazines: ", response);
          this.is_loading = false;
          if (response.data.status) {
            this.magazines = response.data.magazines;
            console.log(
              "obtiene las revistas de el ususario: ",
              this.magazines
            );
          } else {
            this.$snotify.error(
              "Sucedió un error al obtener tus revistas digitales"
            );
          }
        })
        .catch((error) => {
          this.is_loading = false;
          console.error(error);
        });
    },
    getPages: function (year, month) {
      this.is_loading = true;
      var localPages = [null];
      axios({
        method: "GET",
        url:
          this.api_url +
          "/subscriber/" +
          $cookies.get("uidmmkg") +
          "/magazine/" +
          year +
          "/" +
          month,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + $cookies.get("ctoken"),
        },
      })
        .then((response) => {
          this.is_loading = false;
          response.data.magazine.pages.forEach(function (item, index) {
            localPages.push(item);
          });
          this.showMagazine = true;
          //Envio de datos para ver la revista
          this.viewMagazine(this.showMagazine, localPages);
        })
        .catch((error) => {
          this.is_loading = false;
          console.error(error);
        });
      this.pages = localPages;
    },
    getPdf: function (year, month) {
      this.is_loading = true;
      var pdfMagazine = null;
      axios({
        method: "GET",
        url:
          this.api_url +
          "/subscriber/" +
          $cookies.get("uidmmkg") +
          "/magazine/" +
          year +
          "/" +
          month +
          "/" +
          1,
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + $cookies.get("ctoken"),
        },
      })
        .then((response) => {
          console.log(response);
          if (response.data.status) {
            pdfMagazine = response.data.magazine.magazine_url;
          } else {
            this.$snotify.info(
              "Revista Digital no disponible por el momento. Regresa más tarde para poder visualizarla"
            );
          }
          this.showMagazine = true;
          //Envio de datos para ver la revista
          this.viewMagazine(this.showMagazine, pdfMagazine);
        })
        .catch((error) => {
          this.is_loading = false;
            this.$snotify.info(
              "Revista Digital no disponible por el momento. Regresa más tarde para poder visualizarla"
            );
        });
      this.pdfSource = pdfMagazine;
    },
    viewMagazine: function (showMagazine, pdfSource) {
      if (pdfSource != null) {
        this.$router.push({
          name: "viewerMagazine",
          params: {
            showMagazine: showMagazine,
            source: pdfSource,
          },
        });
      } else {
        this.$router.push("/");
      }
    },
  },
  data() {
    return {
      api_url: process.env.VUE_APP_SUSCRIPTIONS_ROUTE,
      pages: [],
      magazines: [],
      showMagazine: false,
      is_loading: false,
      pdfSource: null,
    };
  },
};
</script>

<style scoped>
.containerMagazines {
  min-height: 50vh;
}
.containerMagazines img {
  min-height: 350px;
  min-width: 350px;
}
.magazine-img-grid {
  max-width: 100%;
}
.button-magazine {
  border: none;
  padding: 0;
  margin: 0;
}
@media (max-width: 1200px) {
  .containerMagazines img {
    min-height: auto;
    min-width: 100%;
  }
}
</style>
